module.exports = __webpack_public_path__ + "img/carousel1.f3fd6d7c.png";